













import { Component, Vue } from 'vue-property-decorator';
import AuthSwitcher from '@/components/auth-form/AuthSwitcher.vue';
import LoginForm from '@/components/auth-form/LoginForm.vue';
import AuthSwitcherMobile from '@/components/auth-form/AuthSwitcherMobile.vue';

@Component({
  name: 'LogIn',
  components: { AuthSwitcherMobile, AuthSwitcher, LoginForm }
})
export default class SignIn extends Vue {}
